import * as yup from 'yup';

export const dogSchema = yup.object({
  rasse: yup.string().default('').required().notOneOf(['-1']),
  mischling: yup.boolean().default(false),
  mischlingsrasse: yup
    .string()
    .default('')
    .when('mischling', {
      is: (mischling: boolean) => mischling,
      then: yup.string().required().notOneOf(['-1']),
    }),
});

export type DogSchema = yup.Asserts<typeof dogSchema>;
